import { Box } from '@material-ui/core';
import { AIProductMatchBadge, SText } from '@setvi/shared/components';
import { MatchIndicator } from 'pages/auto-rfq/components/product-card/components';

interface AdditionalContentProps {
  percentage: number;
  prefix?: string;
  text: string;
  withBottomBorder?: boolean;
  customChip?: JSX.Element;
  disabled?: boolean;
}
const contentHeight = 80;
const margin = 12;
export const additionalContentHeight = contentHeight + 2 * margin;

export const AdditionalContent = ({
  percentage,
  customChip,
  disabled,
  prefix,
  text,
  withBottomBorder = false
}: AdditionalContentProps) => (
  <Box
    height={contentHeight}
    display="flex"
    alignItems="center"
    width="100%"
    style={{
      borderTop: '1px solid #E0E0E0',
      minHeight: 44,
      borderBottom: withBottomBorder ? '1px solid #E0E0E0' : 'none'
    }}
    py={margin}>
    <Box
      style={{
        gap: 12,
        display: 'flex',
        alignItems: 'center'
      }}>
      <Box
        style={{
          width: 110,
          minWidth: 110,
          gridGap: 6,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
        {!!customChip && customChip}
        {percentage && (
          <AIProductMatchBadge
            value={percentage}
            fontSize={12}
            disabled={disabled}
          />
        )}
        {percentage > 0 && (
          <MatchIndicator percentage={percentage} disabled={disabled} />
        )}
      </Box>

      {!!text && (
        <Box flex={1}>
          <SText
            fontColor={disabled ? '#AFBAC6' : '#333D47'}
            prefix={
              !!prefix && (
                <b
                  style={{
                    color: disabled ? '#AFBAC6' : '#20262D',
                    marginRight: 4
                  }}>
                  {prefix}
                </b>
              )
            }
            size="sm"
            maxLines={3}
            lineHeight="20px"
            title={text}>
            {text}
          </SText>
        </Box>
      )}
    </Box>
  </Box>
);
